class Twitter {
  /**
   * Share your tweet. Opens a twitter intent popup.
   * @param  {string} tweet    The Tweet to be Sent out
   * @param  {string} link     =             this.getCurrentLink() Link to be sent out
   * @param  {array} hashtags =             []   Array of hashtags to be appended to tweet
   * @param  {string} via      =             ''   @via added to the end of tweet (normally clients twitter handle)
   * @return {void}
   */
  share (link = this.getCurrentLink(), tweet = '', hashtags = [], via = '') {
    let url = 'https://twitter.com/intent/tweet'

    url += '?text=' + encodeURIComponent(tweet)
    url += '&url=' + encodeURIComponent(link)

    if (hashtags.length > 0) {
      url += '&hashtags=' + encodeURIComponent(hashtags.join())
    }

    if (via !== '') {
      url += '&via=' + via
    }

    this.doPopup(url)

    return this
  }

  follow (screenName, referer = this.getCurrentLink()) {
    let url = `https://twitter.com/intent/follow?original_referer=${referer}&screen_name=${screenName}`

    this.doPopup(url)

    return this
  }

  doPopup (url, width = 550, height = 420) {
    let size = this.getPopupSize(width, height)

    window.open(
      url,
      'intent',
      'scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=' +
        size.width +
        ',height=' +
        size.height +
        ',top=' +
        size.top +
        ',left=' +
        size.left
    )
  }

  getPopupSize (width = 550, height = 420) {
    let data = {
      width: width,
      height: height,
      letf: 0,
      top: 0,
    }
    let winWidth = window.screen.width
    let winHeight = window.screen.height

    // Set Left
    data.left = Math.round(winWidth / 2 - width / 2)

    // Set Top
    if (winHeight > height) {
      data.top = Math.round(winHeight / 2 - height / 2)
    }

    return data
  }

  getCurrentLink () {
    return window.location.href
  }
}

export default new Twitter()
